import { Row, Col, Card } from "reactstrap";
import { H6, Progressbar } from "../../../../AbstractElements";
import { CustomProgressBars, GettingStarted } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CUSTOM_PROGRESS_DATA, CUSTOM_PROGRESS_LIST } from "../../../../Data/UiKit/Progress/index";
import { Fragment } from "react";

export const CustomProgressBarsCart = () => {
  return (
    <Card>
      <CommonCardHeader title={CustomProgressBars} span={CUSTOM_PROGRESS_DATA} />
      <Row className="card-body progress-showcase">
        <Col>
          <H6 className="mb-2">{GettingStarted}</H6>
          <Progressbar color="dark" value="0" className="text-center mb-4"></Progressbar>
          {CUSTOM_PROGRESS_LIST.map(({ color, value, title, text }, index) => (
            <Fragment key={index}>
              <H6 className="mb-2">{title}</H6>
              <Progressbar color={color} striped animated value={value} className=" mb-4">{text}</Progressbar>
            </Fragment>
          ))}
        </Col>
      </Row>
    </Card>
  );
};
